export default __webpack_public_path__ + "static/media/image-slider-2-image-header-11-4-23.e56f0f5d.png";